import React, { useState } from 'react';

import noavatar from '../public/images/noavatar.png';

type AvatarImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

// An avatar <img> that shows the default avatar when there is no URL or the image
// fails to load, e.g. an uploaded file that no longer exists on the server.
// A new src is tried again; the default itself is never retried, so it can't loop.
const AvatarImage: React.FC<AvatarImageProps> = ({ src, onError, ...props }) => {
    const [failedSrc, setFailedSrc] = useState<string | undefined>();
    const showDefault = !src || src === failedSrc;

    return (
        <img
            {...props}
            src={showDefault ? noavatar : src}
            onError={(event) => {
                if (!showDefault) {
                    setFailedSrc(src);
                }
                onError?.(event);
            }}
        />
    );
};

export default AvatarImage;
